/*
 *
 * Virtual Market
 * metrics-utils -> Funciones para manejo de metricas
 *
 * RYNDEM 2017
 *
 */

import protocols, { DEBUG } from 'common-protocols'
import _ from 'lodash'
const OBJECT_ID = 'metrics-utils'



export function addMetricsToArray(array, idProduct, time) {

  DEBUG && console.log(OBJECT_ID + '@addMetricsToArray: idProducto:' + idProduct + ' tiempo:' + time);

  let collection = _.slice(array);
  const productIndex = _.findIndex(collection, o => { return o.idProducto === idProduct });

  if (productIndex === -1) {
    collection.push({ 'idProducto': idProduct, 'tiempo': time });
    return collection;
  }

  let updatedItem = JSON.parse(JSON.stringify(collection[productIndex]));
  updatedItem.tiempo += time;
  collection[productIndex] = updatedItem;
  return collection;
}


export function patchMetrics(collection, nameMetric) {
  DEBUG && console.log(OBJECT_ID + '@patchMetrics: Metrica a parchar:' + nameMetric);

  let metrics = [];

  _.forEach(collection, o => {
    metrics.push({ name: nameMetric, value: o.tiempo });
  });

  return metrics;
}

export function addIdBoletoMetrica(collection, results, maxLenght) {
  let term = [];

  _.forEach(collection, (object, index) => {
    if (index <= maxLenght) {
      term.push({ idBoletoMetrica: object.idBoletoMetrica, idProducto: results[index].idProducto });
    }
  });

  return term;
}



// WEBPACK FOOTER //
// ./src/utilities/metrics-utils.js